import React, { useState, useEffect } from 'react';
import AddressTable from "../../../components/tables/AddressTable";
import {getAdminUserAddress} from "../../../store/action/user";
import {getGeocode} from "../../../store/action/location";
import {createAdminAddress} from "../../../store/action/address";
import {trackEvent} from "../../../services/analytics";
import Modal from "../../../components/molecules/Modal";
import AddressForm from "../../../components/forms/AddressForm";

const AdminUserAddress = ({user,token}) => {
    const [ addressForm, setAddressForm ] = useState(false);
    const [ addresses, setAddresses ] = useState([]);
    const [ loading, setloading ] = useState(true);
    const [ locLoading, setLocLoading ] = useState(false);
    const initialState = {
        addressId:'',
        addressName:'',
        addressDetails:'',
        addressPIC:'',
        coordinate: {
            latitude:'',
            longitude:''
        },
        postalCode:0,
        provinceId:0,
        provinceName:'-',
        cityId:0,
        cityName:'-',
        districtId:0,
        districtName:'-',
        subdistrictId:0,
        subdistrictName:'-',
        stores:[],
        error:false,
        success:false
    };
    const [ values, setValues ] = useState(initialState);

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const resUs = await getAdminUserAddress(user.id,token);
            if (resUs.success) {
                const us = resUs.addresses;
                const addresses = us.reduce((result, i) => {
                    result.push({
                        addressId:i._id,
                        addressName:i.name,
                        addressPIC:i.PIC,
                        addressDetails: i.details,
                        addressNote:i.note,
                        coordinate:i.coordinate,
                        postalCode: i.postalCode,
                        provinceId: i.provinceId,
                        provinceName: i.provinceName,
                        cityId: i.cityId,
                        cityName: i.cityName,
                        districtId: i.districtId,
                        districtName: i.districtName,
                        subdistrictId: i.subdistrictId,
                        subdistrictName: i.subdistrictName,
                        stores:i.stores
                    });
                    return result
                }, []);
                setAddresses(addresses)
            } else {
                alert(resUs.error)
            }

        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setloading(false)
    };

    const onRefresh = () => {
        _fetchData()
    };

    const onSelectLocation = async (a,c) => {
        setLocLoading(true);
        const res = await getGeocode(token, c);
        if (res.success){
            setValues({
                ...values,
                error: false,
                success:false,
                addressDetails:a,
                coordinate:c,
                ...res.location
            })
        } else {
            alert("Alamat yang Anda pilih kurang spesifik. Usahakan masukan alamat seperti nama toko, nama komplek perumahan atau nama jalan. Terima kasih.");
            setValues({
                ...values,
                error: false,
                success:false
            });
        }
        setLocLoading(false);
    };

    const onLocationChange = address => {
        setValues({...values, addressDetails:address})
    };

    const onStoreChange = stores => {
        setValues({...values, stores})
    };

    const handleChange = name => event => {
        setValues({ ...values, error: false, success:false, [name]: event.target.value });
    };

    const onSubmitNewAddress = () => {
        let address = values;
        if (!address.addressName) {
            alert( "Nama kontak di lokasi tempat masih kosong. Mohon diisi");
            return
        }
        if (!address.addressPIC) {
            alert( "Nomor telepon kontak di lokasi masih kosong. Mohon diisi");
            return
        }
        if (!address.addressNote) {
            alert( "Keterangan tempat masih kosong. Mohon diisi");
            return
        }
        delete address.addresses;
        createAdminAddress(user.id, token, address)
            .then(data => {
                if(data.error) {
                    setValues({...values, error: data.error})
                } else {
                    trackEvent("Address Created",{
                        action: "track",
                        category: "Addresses",
                        label: 'Create New Address',
                        event: "Click"
                    });
                    setValues(initialState);
                    alert("Alamat berhasil ditambahkan");
                    window.location.reload();
                }
            })
    };

    const showSuccess = () => {
        if(values.success){
            return (
                <div
                    className="alert alert-success mb-0"
                    style={{display: values.success ? '' : 'none'}}
                >
                    Berhasil dibuat
                </div>
            )
        }
    };

    const showError = () => {
        if(values.error){
            return (
                <div
                    className="alert alert-danger mb-0"
                    style={{display: values.error ? '' : 'none'}}
                >
                    {values.error}
                </div>
            )
        }
    };

    const handleModalClose = () => {
        setAddressForm(false)
    };
    const handleModalOpen = () => {
        setAddressForm(true)
        setValues(initialState)
    };

    const modalView = () => {
        return (
            <Modal
                show={addressForm}
                onHide={handleModalClose}
                title="Buat Alamat Baru"
                bodyClassName="p-0"
                buttons
                type="yesno"
                lbText="Kembali"
                rbText="Simpan"
                lbClick={handleModalClose}
                rbClick={() => onSubmitNewAddress()}
                footerStyle={{justifyContent:'flex-end'}}
            >
                { showSuccess() }
                { showError() }
                <div className="p-4">
                    <AddressForm
                        button={false}
                        data={values}
                        handleChangeLocation={onLocationChange}
                        handleChangeStore={onStoreChange}
                        handleChange={handleChange}
                        locationLoading={locLoading}
                        onSubmitText="Tambah Alamat"
                        onSelectLocation={onSelectLocation}
                    />
                </div>
            </Modal>
        );
    };

    if (loading) {
        return <p>Loading...</p>
    }

    return (
        <div>
            { modalView() }
            <div className="p-4">
                <div className=" d-flex justify-content-between">
                    <h5>Alamat Tersimpan </h5>
                    <button
                        className="btn btn-primary"
                        onClick={handleModalOpen}
                    >
                        Tambah Alamat
                    </button>
                </div>
            </div>
            <AddressTable
                data={addresses}
                loading={loading}
                onRefresh={onRefresh}
            />
        </div>
    )
};



export default AdminUserAddress;
